import React from 'react';

import cn from 'classnames';
import { noop } from 'lodash';
import { string, bool, node, func } from 'prop-types';
import { Link } from 'react-router-dom';

import Text from 'components/Common/Text';

import { isAbsoluteLink } from 'utils/urls';

import s from './TextLink.css';

const TextLink = ({
  href,
  color,
  children,
  className,
  forceUnderline,
  forceDisableNewTab,
  onClick,
  ...textProps
}) => {
  const RenderComponent = props =>
    isAbsoluteLink(href) ? (
      <a
        {...props}
        href={href}
        target={forceDisableNewTab ? '_self' : '_blank'}
        rel="noreferrer"
        onClick={onClick}
      >
        {children}
      </a>
    ) : (
      <Link {...props} href={href} to={href} onClick={onClick}>
        {children}
      </Link>
    );

  return (
    <Text
      display="inline"
      color={color}
      className={cn('textLink', className, {
        [s.blueHover]: color === 'blueXtraDark',
        [s.underline]: forceUnderline,
      })}
      {...textProps}
    >
      <RenderComponent {...textProps} />
    </Text>
  );
};

TextLink.propTypes = {
  color: string,
  className: string,
  href: string,
  children: node.isRequired,
  /* If true, adds an underline beneath the text to indicate a hyperlink */
  forceUnderline: bool,
  /* If true, disables opening the link in a new page */
  forceDisableNewTab: bool,
  /* Can pass onClick callback func - useful to stop event propagation */
  onClick: func,
};

TextLink.defaultProps = {
  className: '',
  color: 'blueXtraDark',
  forceUnderline: false,
  forceDisableNewTab: false,
  href: '#',
  onClick: noop,
};

export default TextLink;
